import { render, staticRenderFns } from "./ModalSeries.vue?vue&type=template&id=06d75ecf&"
import script from "./ModalSeries.vue?vue&type=script&lang=ts&"
export * from "./ModalSeries.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSeries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('06d75ecf', component.options)
    } else {
      api.reload('06d75ecf', component.options)
    }
    module.hot.accept("./ModalSeries.vue?vue&type=template&id=06d75ecf&", function () {
      api.rerender('06d75ecf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/PreparacionEquipos/ModalSeries.vue"
export default component.exports